var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPng(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.1142 9.79783C27.2485 9.79658 26.4185 9.45199 25.8065 8.83965C25.1944 8.22731 24.8503 7.39722 24.8494 6.53145V2H10.2623C9.70268 1.99979 9.14844 2.10985 8.63132 2.32387C8.11421 2.5379 7.64432 2.8517 7.24851 3.24736C6.8527 3.64303 6.53871 4.11279 6.3245 4.62983C6.11028 5.14686 6.00002 5.70103 6.00002 6.26069V31.9389C5.99815 32.4998 6.10702 33.0555 6.3204 33.5742C6.53378 34.0929 6.84749 34.5643 7.24348 34.9615C7.63948 35.3587 8.10999 35.6737 8.62804 35.8887C9.14608 36.1036 9.70148 36.2141 10.2623 36.2139H27.7738C28.9038 36.2139 29.9875 35.765 30.7866 34.966C31.5856 34.1669 32.0345 33.0832 32.0345 31.9532V9.79783H28.1142Z",
    fill: "#005FAD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0356 9.79783H28.1153C27.2495 9.79658 26.4196 9.45199 25.8075 8.83965C25.1955 8.22731 24.8513 7.39722 24.8505 6.53145V2L32.0356 9.79783Z",
    fill: "#005FAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1251 29.0117H15.3274C13.923 29.0117 12.7845 30.1502 12.7845 31.5545V37.4571C12.7845 38.8615 13.923 39.9999 15.3274 39.9999H35.1251C36.5295 39.9999 37.6679 38.8615 37.6679 37.4571V31.5545C37.6679 30.1502 36.5295 29.0117 35.1251 29.0117Z",
    fill: "#005FAD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5198 35.7847V36.9357H17.3275V35.7847H18.5198Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2666 35.2645V36.9349H19.1155V32.1738H20.9806C21.5459 32.1738 21.9765 32.3132 22.2726 32.595C22.4225 32.7419 22.5396 32.9189 22.6163 33.1142C22.693 33.3096 22.7275 33.519 22.7175 33.7287C22.7219 34.0053 22.6536 34.2783 22.5196 34.5203C22.3812 34.7569 22.1756 34.947 21.929 35.0666C21.6324 35.2064 21.3069 35.2742 20.979 35.2645H20.2666ZM21.5458 33.7287C21.5458 33.3128 21.3147 33.1017 20.8524 33.0953H20.2666V34.3335H20.8524C21.3147 34.3398 21.5458 34.1387 21.5458 33.7302V33.7287Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5164 36.9363H26.3653L24.44 34.0135V36.9363H23.2874V32.1753H24.44L26.3653 35.125V32.1753H27.5164V36.9363Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0151 32.5716C32.3989 32.8597 32.6574 33.2843 32.7371 33.7575H31.5179C31.4383 33.5876 31.3092 33.4457 31.1474 33.3506C30.9114 33.2215 30.6398 33.1727 30.3736 33.2116C30.1074 33.2504 29.8611 33.3748 29.6718 33.5659C29.4401 33.8431 29.3224 34.198 29.3425 34.5587C29.3425 35.0131 29.458 35.3598 29.6892 35.6021C29.819 35.7285 29.9738 35.8262 30.1437 35.8889C30.3136 35.9516 30.4948 35.978 30.6756 35.9662C30.9338 35.9715 31.1867 35.8926 31.396 35.7414C31.6097 35.5813 31.7641 35.3546 31.8346 35.097H30.3795V34.2689H32.7972V35.4073C32.7042 35.6905 32.5581 35.9533 32.3666 36.1816C32.1588 36.4275 31.9 36.6253 31.6082 36.7611C31.2786 36.9142 30.9185 36.99 30.5553 36.9827C30.1135 36.9943 29.6765 36.8889 29.2886 36.6772C28.9342 36.4778 28.6453 36.1796 28.4574 35.819C28.2643 35.4272 28.1639 34.9963 28.1639 34.5595C28.1639 34.1227 28.2643 33.6917 28.4574 33.2999C28.6446 32.9399 28.9323 32.6418 29.2854 32.4418C29.6674 32.2308 30.0984 32.1248 30.5347 32.1346C31.063 32.1114 31.584 32.2652 32.0151 32.5716Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6617 12.5645H12.4846V14.7415H14.6617V12.5645Z",
    fill: "#005FAD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8395 14.7407H14.6625V16.9178H16.8395V14.7407Z",
    fill: "#005FAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0135 12.5645H16.8364V14.7415H19.0135V12.5645Z",
    fill: "#005FAD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1913 14.7407H19.0143V16.9178H21.1913V14.7407Z",
    fill: "#005FAD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3729 12.5645H21.1958V14.7415H23.3729V12.5645Z",
    fill: "#005FAD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5506 14.7407H23.3735V16.9178H25.5506V14.7407Z",
    fill: "#005FAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6617 16.915H12.4846V19.0921H14.6617V16.915Z",
    fill: "#005FAD"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8395 19.0918H14.6625V21.2689H16.8395V19.0918Z",
    fill: "#005FAD"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0135 16.915H16.8364V19.0921H19.0135V16.915Z",
    fill: "#005FAD"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1913 19.0918H19.0143V21.2689H21.1913V19.0918Z",
    fill: "#005FAD"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3729 16.915H21.1958V19.0921H23.3729V16.915Z",
    fill: "#005FAD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5506 19.0918H23.3735V21.2689H25.5506V19.0918Z",
    fill: "#005FAD"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6617 21.2861H12.4846V23.4632H14.6617V21.2861Z",
    fill: "#005FAD"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8395 23.4634H14.6625V25.6404H16.8395V23.4634Z",
    fill: "#005FAD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0135 21.2861H16.8364V23.4632H19.0135V21.2861Z",
    fill: "#005FAD"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1913 23.4634H19.0143V25.6404H21.1913V23.4634Z",
    fill: "#005FAD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3729 21.2861H21.1958V23.4632H23.3729V21.2861Z",
    fill: "#005FAD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5506 23.4634H23.3735V25.6404H25.5506V23.4634Z",
    fill: "#005FAD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPng);
export default __webpack_public_path__ + "static/media/png.be0121b19103eae4c32ac2da52b17fb8.svg";
export { ForwardRef as ReactComponent };